import React, { useState } from 'react';
import { CommissionDashboard } from './components/CommissionDashboard';
import { UserRole } from './types/commission';
export function App() {
  const [currentRole, setCurrentRole] = useState<UserRole>('Loan Officer');
  return <CommissionDashboard currentRole={currentRole} onRoleChange={setCurrentRole} data-id="element-0" />;
}